import {getProductList} from "@/api/Product"

export default {
  addProduct({ commit }, product) {
    return new Promise((resolve, reject) => {
      commit('ADD_PRODUCT', product)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsProduct({ commit },payload) {
    return new Promise((resolve, reject) => {
      getProductList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_PRODUCT', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateProduct({ commit }, product) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_PRODUCT', product)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeProduct({ commit }, productId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_PRODUCT', productId)
          resolve();
    })
  },
};
